import React, { Component } from 'react';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { Grid, Popper, Typography } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import instance from '../../request/http';
import { BASE_URL } from '../../store/config';
import Autocomplete from '@material-ui/lab/Autocomplete';
import debounce from 'lodash/debounce';

/*
This component supports client autocomplete selector
props:
initClient: {id, email, last_name, first_name} NOTE: null will show current client
update: callback, used to update father's client value
 */

class ClientAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.initClient = null;

        if (this.props.initClient) {
            this.initClient = this.props.initClient;
        }

        this.state = {
            client: this.initClient,
            clientOptions: [],
        };

        console.log("INIT>>>>>>>>>>.");

        // set current client as default
        this.props.update(this.initClient);

        // value changing may invoke change and inputChange at the same time.
        // This variable is used to block some useless inputChange events
        this.block = false;

        this.handleFocusout = this.handleFocusout.bind(this);
        this.handleAutoChange = this.handleAutoChange.bind(this);
        this.handleAutoInputChange = this.handleAutoInputChange.bind(this);
        this.handleAutoInputThrottled = debounce(this.handleAutoInputChange, 200);
    }

    render() {
        const {
            client,
            clientOptions,
        } = this.state;

        console.log(clientOptions);

        const acPopper = function (props) {
            return (<Popper {...props} style={{ width: 'auto', minWidth: '300px' }} placement='bottom-start' />)
        };

        return (
            <Autocomplete
                style={{ margin: 0, width: '100%', backgroundColor: '#fff' }}
                value={client}
                onChange={this.handleAutoChange}
                onBlur={this.handleFocusout}
                onInputChange={this.handleAutoInputThrottled}
                options={clientOptions}
                getOptionSelected={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.individual ? option.individual.first_name + " " + option.individual.last_name : option.corporation.name}
                filterOptions={(x) => x}
                PopperComponent={acPopper}
                renderInput={(params) => (
                    <TextField {...params} margin="dense" variant="outlined" label="Input the Existed Client (Name / Email / Phone)" type="search" fullWidth  />
                )}
                renderOption={(option) => {
                    return (
                        <Grid container alignItems="center">
                            <Grid item style={{ marginRight: 10 }}>
                                <AccountBoxIcon />
                            </Grid>
                            <Grid item xs>
                                {option.individual ? option.individual.first_name + " " + option.individual.last_name : option.corporation.name}
                                <Typography variant="body2" color="textSecondary">
                                    {option.individual ? option.individual.email : ""}
                                </Typography>
                            </Grid>
                        </Grid>
                    );
                }}
            />
        );
    }
    componentDidUpdate(prevProps) {
        if (this.props.initClient !== prevProps.initClient) {
            const initClient = this.props.initClient;
            if (initClient) {
                console.log("======initClient=====", initClient)
                this.initClient = initClient;
                this.setState(() => ({
                    client: initClient
                }))
            }
        }
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    // block request after the focusout event
    handleFocusout() {
        this.block = true;
        this.setState(() => ({
            clientOptions: [],
        }));
    }

    handleAutoChange(e, value) {
        console.log("====选择===");
        console.log(value);

        // only happens when clearing all the inputs
        if (value === null) {
            return;
        }

        this.block = true;
        // update the father's value
        this.props.update(value);
        this.setState(() => ({
            client: value,
        }));
    }

    handleAutoInputChange(e, value) {
        console.log("====输入===");
        console.log(value);

        if (this.block) {
            this.block = false;
            return;
        }

        // simply clear the clientOptions if the input is empty
        if (value === null || value === "") {
            this.setState(() => ({
                clientOptions: [],
            }));
            return;
        }


        const params = {
            search_content: value,
        }
        instance.get(BASE_URL + 'clients/fuzzy_matching', { params }).then((res) => {
            let clients = res.data.data;
            let cData = clients.corp_data;
            let iData = clients.individual_data;
            let newClients = [];
            for (const obj of iData) {
                newClients.push(obj);
            }
            if(this.props.allClient === true){
                for (const obj of cData) {
                    newClients.push(obj);
                }
            }
            console.log(newClients)
            this.setState(() => ({
                clientOptions: newClients,
            }));
        }).catch((err) => {
            // const msg = err.response.data.message;
            // this.showToast(msg, "error");
        })
    }

}

export default ClientAutoComplete;